import {Component} from "@angular/core";
import {provideEntityModel, provideSearchModel} from "@fedeltapointofsale/data-client";
import {ProductContainerSearchModel} from "../product-container-search.model";
import {ProductContainerEntityModel} from "../product-container-entity.model";
import {AbstractSearchPage} from "../../../framework/entity/search/search-page/abstract-search-page";

@Component({
    selector: "wbo-product-container-search-page",
    templateUrl: "./product-container-search-page.component.html",
    providers: [provideSearchModel(ProductContainerSearchModel), provideEntityModel(ProductContainerEntityModel)]
})
export class ProductContainerSearchPageComponent extends AbstractSearchPage {

}
